export const faqContent = {
    es: {
        eyebrow: 'FAQ',
        title: 'Descubre las respuestas a las preguntas más frecuentes en nuestras FAQ.',
        items: [
            {
                question: '¿El precio es mensual? ¿Se me volverá a cobrar?',
                answer: 'No, es un pago único. No cobramos cuotas mensuales ni renovamos tu suscripción automáticamente. Pagas una sola vez y obtienes acceso durante el periodo elegido (por ejemplo, un año, 15 meses o 24 meses).',
            },
            {
                question: '¿Cómo recibo mi suscripción?',
                answer: 'Tras el pago, recibirás tus credenciales por email en un plazo de 10 a 30 minutos. Revisa tu carpeta de spam. Si no recibes nada, contáctanos por WhatsApp:',
                hasLink: true,
            },
            {
                question: '¿Cómo me suscribo a IPTV?',
                answer: 'Para suscribirte a IPTV, visita nuestro sitio web y elige la suscripción que mejor se adapte a tus necesidades. Serás redirigido a otro sitio para completar el pago. Una vez hecho esto, recibirás tus códigos con instrucciones detalladas, paso a paso, para instalarlo en tus dispositivos.',
            },
            {
                question: '¿Puedo usar el IPTV en varios dispositivos a la vez?',
                answer: 'Sí, si tienes una suscripción Gold puedes ver el contenido en varios dispositivos al mismo tiempo.',
            },
            {
                question: '¿Por qué se me redirige a otro sitio para completar mi compra?',
                answer: 'Por motivos de seguridad, se te redirige al sitio de nuestro socio de pago de confianza. Una vez finalizada tu compra, recibirás tu código de activación IPTV por email. No dudes en contactarnos ante cualquier duda.',
            },
            {
                question: '¿Necesito una antena parabólica para usar el IPTV?',
                answer: 'No, te conectas a los servidores IPTV de LIGUEE1 a través de Internet y no necesitas ninguna antena ni equipo satelital.',
            },
            {
                question: '¿Puedo pagar mi suscripción con PayPal?',
                answer: 'Sí, puedes pagar tu suscripción con PayPal, Cripto u otros métodos de pago específicos. Para estas opciones de pago, envíanos un mensaje por WhatsApp:',
                hasLink: true,
            },
            {
                question: '¿Este servicio IPTV funciona en mi país?',
                answer: 'El IPTV funciona en cualquier parte del mundo, vivas donde vivas. Mientras dispongas de una conexión a Internet estable, podrás ver miles de canales de TV.',
            },
        ],
    },
};
